import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  createCourseAction,
  editingCourseActions,
  getDetailsCourseForUpdateAction,
  getDetailsCourseForUpdateActions,
} from "@redux/actions";

const useEditingCourse = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const [step, setStep] = useState(1);
  const [autoSave, setAutoSave] = useState(false);

  let courseId = params.id;
  let isUpdate = courseId ? true : false;

  useEffect(() => {
    const handleTabClose = (event) => {
      event.preventDefault();
      return (event.returnValue = "");
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
      dispatch(editingCourseActions.resetEditingCourse());
    };
  }, []);

  useEffect(() => {
    if (isUpdate) {
      dispatch(getDetailsCourseForUpdateAction(courseId));
    }
  }, [courseId]);

  // useEffect(() => {
  //   if (!isUpdate) {
  //     dispatch(createCourseAction());
  //   }
  // }, [isUpdate]);

  return { isUpdate, step, setStep, autoSave, setAutoSave };
};

export { useEditingCourse };
